import {
  BUSINESS_ADDRESS_EDIT_MODAL_OPEN,
  BUSINESS_ADDRESS_EDIT_MODAL_CLOSE,
  BUSINESS_ADDRESS_EDIT_MODAL_SAVE_CHANGES,
  BUSINESS_ADDRESS_EDIT_MODAL_VALIDATE,
  BUSINESS_ADDRESS_EDIT_MODAL_CANCEL,
  BUSINESS_ADDRESS_EDIT_MODAL_RESET,
  BUSINESS_ADDRESS_EDIT_UPDATE_SUCCESS,
  BUSINESS_ADDRESS_EDIT_UPDATE_FAILURE,
  BUSINESS_ADDRESS_EDIT_UPDATE_REQUEST,
} from '../actions/business_address_modal_dialog'

export function businessAddressModalDialog(
  state = {
    isModalDialogOpen: false,
    newData: null,
    isChangesSaved: false,
    isValidated: true,
    content: null,
    isSaving: false,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case BUSINESS_ADDRESS_EDIT_UPDATE_REQUEST:
      return {
        ...state,
        isSaving: true,
        errorMessage: null,
      }
    case BUSINESS_ADDRESS_EDIT_UPDATE_SUCCESS:
      return {
        ...state,
        isSaving: false,
        errorMessage: null,
      }
    case BUSINESS_ADDRESS_EDIT_UPDATE_FAILURE:
      return {
        ...state,
        isSaving: false,
        errorMessage: action.error,
      }
    case BUSINESS_ADDRESS_EDIT_MODAL_OPEN:
      return {
        ...state,
        isModalDialogOpen: true,
        content: action.content,
      }
    case BUSINESS_ADDRESS_EDIT_MODAL_CLOSE:
      return {
        ...state,
        isModalDialogOpen: false,
        isChangesSaved: false,
        isValidated: true,
      }
    case BUSINESS_ADDRESS_EDIT_MODAL_CANCEL:
      return {
        ...state,
        isModalDialogOpen: false,
        isChangesSaved: false,
        isValidated: true,
        newData: null,
      }
    case BUSINESS_ADDRESS_EDIT_MODAL_SAVE_CHANGES:
      return {
        ...state,
        isChangesSaved: true,
        newData: action.newData,
      }
    case BUSINESS_ADDRESS_EDIT_MODAL_VALIDATE:
      return {
        ...state,
        isValidated: action.isValidated,
      }
    case BUSINESS_ADDRESS_EDIT_MODAL_RESET:
      return {
        ...state,
        newData: null,
        isChangesSaved: false,
      }
    default:
      return state
  }
}
